<template>
  <v-container>

    <v-row justify="center" align="center">
      <v-col cols="4">
        <v-img
          :src="require('@/assets/logo-gagarin-blk.png')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-col>
    </v-row>

      <v-row mb-4 justify="center" align="center">
        <v-col cols="6" class=" black--text">
        <h1 class="display-2 font-weight-bold mb-3">
          404 ERROR
        </h1>
        <p class="subheading font-weight-regular">
          К сожалению такой страницы на нашем сайте нет!
        </p>
        <p>Попробуйте выбрать нужный раздел из меню слева</p>
        </v-col>

      </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'HelloWorld',

  data: () => ({
    ecosystem: [
      {
        text: 'vuetify-loader',
        href: 'https://github.com/vuetifyjs/vuetify-loader',
      },
      {
        text: 'github',
        href: 'https://github.com/vuetifyjs/vuetify',
      },
      {
        text: 'awesome-vuetify',
        href: 'https://github.com/vuetifyjs/awesome-vuetify',
      },
    ],
    importantLinks: [
      {
        text: 'Documentation',
        href: 'https://vuetifyjs.com',
      },
      {
        text: 'Chat',
        href: 'https://community.vuetifyjs.com',
      },
      {
        text: 'Made with Vuetify',
        href: 'https://madewithvuejs.com/vuetify',
      },
      {
        text: 'Twitter',
        href: 'https://twitter.com/vuetifyjs',
      },
      {
        text: 'Articles',
        href: 'https://medium.com/vuetify',
      },
    ],
    whatsNext: [
      {
        text: 'Explore components',
        href: 'https://vuetifyjs.com/components/api-explorer',
      },
      {
        text: 'Select a layout',
        href: 'https://vuetifyjs.com/layout/pre-defined',
      },
      {
        text: 'Frequently Asked Questions',
        href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions',
      },
    ],
  }),
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
        titleInnert: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        }    
  },
   mounted () {    
    if(DEBUG) console.log('mounted Contacts')
    let vApp = this
    this.$nextTick(function () {
      vApp.titleInnert = '404 Страница не найдена';
    })
  } 
};
</script>
